export default function BarangCabang({ barangCabang, loadingDataCabang }) {
  return <div></div>;
}
